// src/components/games/PointsEarnedRow.jsx
// 🟢 [修复] 三个游戏的结算画面此前都把「客户端原始分」当成入账积分显示
// （WordScramble / WordSearch 直接写 "Points Earned: {score}"）。
// 实际入账值由后端决定：routes/games.js 会把分数 clamp 到 MAX_GAME_POINTS=500，
// 再加上当日的每日任务奖励，然后把真实值放在响应的 pointsEarned 里。
// 三个游戏本来都拿到了这个值却丢掉了 —— 于是一局 80 词的 Vocab Survival
// 会显示 "Points Earned: 800"，而实际只进账 500。
//
// pointsEarned 的三种状态，一个都不能谎报：
//   null       -> 还在提交（endGame 是异步的，结算画面先出来）
//   'failed'   -> 提交失败，这一局没入账
//   number     -> 后端确认入账的真实积分
import React from 'react';

// 与 routes/games.js 的 MAX_GAME_POINTS 对齐
const MAX_GAME_POINTS = 500;

const PointsEarnedRow = ({ score, pointsEarned }) => {
  // 三个游戏都有 if (finalScore > 0) 这道门，0 分根本不会提交，也就没有积分可言
  if (!score || score <= 0) return null;

  if (pointsEarned === null || pointsEarned === undefined) {
    return <div className="text-lg text-gray-600">Saving your points…</div>;
  }

  if (pointsEarned === 'failed') {
    return (
      <div className="text-lg font-semibold text-red-500">
        Couldn&apos;t save your points — check your connection and play again.
      </div>
    );
  }

  // 被 500 上限截掉了才提示，正常情况不啰嗦。
  // 注意 pointsEarned 也可能【大于】score（当天第一局有每日任务奖励）。
  const capped = pointsEarned < score;

  return (
    <div>
      <div className="text-lg font-bold text-gray-800">Points Earned: +{pointsEarned}</div>
      {capped && (
        <div className="mt-1 text-sm text-gray-500">
          Max {MAX_GAME_POINTS} points per game
        </div>
      )}
    </div>
  );
};

export default PointsEarnedRow;
